/**
 * WindView貼り付けデータの永続化。
 *
 * pibal-store.ts の記録保存と同じく、会場ごとに localStorage キーを分ける
 * （大会・会場を跨ぐと風プロファイルの意味が変わるため）。
 */

import type { WindSample } from '@gv4d/core';

const SAMPLES_KEY_PREFIX = 'gv4d-windview-samples:';

export function loadWindviewSamples(venueId: string): WindSample[] {
  try {
    const raw = localStorage.getItem(SAMPLES_KEY_PREFIX + venueId);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? (parsed as WindSample[]) : [];
  } catch {
    return [];
  }
}

export function saveWindviewSamples(venueId: string, samples: WindSample[]): void {
  try {
    localStorage.setItem(SAMPLES_KEY_PREFIX + venueId, JSON.stringify(samples));
  } catch {
    // 保存できなくてもその場の操作は続けられる
  }
}
